import { render, staticRenderFns } from "./historycollectortodebiturfrm.vue?vue&type=template&id=2c617a41&"
import script from "./historycollectortodebiturfrm.vue?vue&type=script&lang=js&"
export * from "./historycollectortodebiturfrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports